import React from 'react';
import PropTypes from 'prop-types';

function Tooltip({ children, title, position, styles }) {
  return (
    <span className="TooltipWrapper">
      {children}
      <span className="TooltipBubble" data-position={position} style={styles?.tooltipBubble || {}}>
        {title}
      </span>
    </span>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: PropTypes.shape({
    tooltipBubble: PropTypes.object
  })
};

Tooltip.defaultProps = {
  position: 'top'
};

export default Tooltip;
